import {
  GET_STRUCTURE_TYPES
} from '../mutation-types'

const state = {
  all: []
}

const mutations = {
  [GET_STRUCTURE_TYPES] (state, data) {
    state.all = data
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/structureTypes.js